import {IColorGradient, ITextSelectionInformation, IElement, IShapeCircleAttributes, IShapeCommonAttributes, IShapeEllipseAttributes, IShapeRectangleAttributes, IShapeTriangleAttributes, ITextAttributes} from 'routes/private/Editor/types';
import { execCommandToSelectedText, updateRenderingTextSegments } from 'utils/textMultiStyling'

export const fontColorResolver = ( element: IElement, value: string, textSelectionInformation?: ITextSelectionInformation ) => {
    if (element.type === "Text") {
        const attributes = execCommandToSelectedText("color", (element.attributes as ITextAttributes), textSelectionInformation, value);
        element.attributes = updateRenderingTextSegments(attributes);
    }
    return element;
}

export const backgroundColorResolver = ( element: IElement, value: string ) => {
    (element.attributes as IShapeCircleAttributes | IShapeRectangleAttributes | IShapeTriangleAttributes | IShapeEllipseAttributes).backgroundColor = value;    
    if (element.attributes.shapeType === "Line") element.attributes.borderColor = value;
    return element;
}

export const bgGradientResolver = ( element: IElement, value: IColorGradient ) => {
    (element.attributes as IShapeCommonAttributes).bgGradient = value;            
    return element;
}


export const borderColorResolver = ( element: IElement, value: string ) => {    
    (element.attributes as IShapeCommonAttributes).borderColor = value;            
    if (element.attributes.shapeType === "Line") element.attributes.backgroundColor = value;
    return element;
}


